import Button from '../Button';
import StarRating from '../../StarRating';
import { TItemWebImages } from '@types';
import WebImage from '@components/tailwind/WebImage';
import { Link } from '@components/Link';

type Props = {
  product: ProductSliderProduct;
  starsColor?: string;
  starsSize?: string;
  showAddToCart?: boolean;
};

export type ProductSliderProduct = {
  url: string;
  webImages: TItemWebImages;
  displayName: string;
  rating: {
    count: number;
    rating: number;
  };
  rateFormatted: number;
  id: string;
  isBundle: boolean;
};

const Card = ({ product, starsColor, showAddToCart = true, starsSize = '22px' }: Props) => {
  return (
    <div className='tw:p-2'>
      <div className='tw:block tw:rounded-lg tw:border tw:border-gray-300 tw:bg-white tw:p-4 tw:shadow-md tw:md:p-6'>
        <Link
          href={product.url}
          className='tw:mb-0 tw:block tw:text-ellipsis tw:text-base tw:font-bold tw:text-brand-black tw:no-underline tw:transition tw:duration-150 tw:line-clamp-1 tw:hover:text-brand-black tw:hover:no-underline tw:hover:opacity-60 tw:md:text-lg'>
          {product.displayName}
        </Link>
        {!product.isBundle && (
          <StarRating
            itemName={product.displayName}
            starsColor={starsColor}
            fontSize={starsSize}
            reviewCount={product.rating.count}
            reviewRating={product.rating.rating}
          />
        )}
        <p className='tw:mb-0 tw:text-base tw:font-bold tw:text-brand-black'>{product.rateFormatted}</p>

        <Link
          className='tw:my-10 tw:block tw:h-[250px] tw:no-underline tw:hover:no-underline'
          href={product.url}>
          <WebImage
            webImage={product.webImages.default.active}
            alt={product.displayName}
            className='tw:mx-auto tw:block tw:max-h-full tw:max-w-full'
          />
        </Link>

        {showAddToCart && (
          <form
            action={jsRoutes.controllers.Cart.update().url}
            method='post'
            className='tw:mx-auto tw:flex tw:max-w-[200px] tw:items-center tw:justify-center'>
            <input type='hidden' name='id' value={product.id} />
            <input type='hidden' name='quantity' value='1' />

            <Button variant='primary' fullWidth='all' size='md' value='edit' name='op' type='submit'>
              Add to Cart
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Card;
